import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Phone, Instagram } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';

export const ContactPage = () => {
  const contacts = [
    {
      icon: Mail,
      title: 'E-mail',
      value: 'Suporte@gameodys.com',
      link: 'mailto:Suporte@gameodys.com',
      color: 'green'
    },
    {
      icon: Phone,
      title: 'WhatsApp',
      value: '+55 32 98494-5548',
      link: 'https://wa.me/5532984945548',
      color: 'purple'
    },
    {
      icon: Instagram,
      title: 'Instagram',
      value: '@gameodys',
      link: 'https://www.instagram.com/gameodys/',
      color: 'green'
    }
  ];

  return (
    <div className="min-h-screen bg-dark-primary py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        {/* Back Button */}
        <Link to="/" className="inline-flex items-center text-purple-light hover:text-purple-primary transition-colors mb-8">
          <ArrowLeft className="mr-2" size={20} />
          Voltar para Home
        </Link>

        {/* Page Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl font-bold font-archive text-white mb-4 glow-text">
            Entre em Contato
          </h1>
          <p className="text-xl text-gray-400 font-hero max-w-2xl mx-auto">
            Estamos aqui para ajudar! Entre em contato conosco através dos canais abaixo
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {contacts.map((contact, index) => {
            const Icon = contact.icon;
            const colorClasses = contact.color === 'green' 
              ? 'from-green-primary to-green-secondary border-green-primary/30 hover:border-green-primary/60 hover:shadow-green-primary/20'
              : 'from-purple-primary to-purple-light border-purple-primary/30 hover:border-purple-primary/60 hover:shadow-purple-primary/20';
            
            return (
              <Card 
                key={index}
                className={`bg-dark-secondary border transition-all duration-500 hover:scale-105 hover:shadow-2xl ${colorClasses}`}
              >
                <CardHeader className="text-center">
                  <div className={`mx-auto mb-4 w-20 h-20 bg-gradient-to-br ${contact.color === 'green' ? 'from-green-primary to-green-secondary' : 'from-purple-primary to-purple-light'} rounded-2xl flex items-center justify-center shadow-lg`}>
                    <Icon className="text-white" size={40} strokeWidth={2} />
                  </div>
                  <CardTitle className="text-2xl font-archive text-white mb-2">
                    {contact.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center">
                  <a 
                    href={contact.link}
                    target={contact.link.startsWith('http') ? '_blank' : undefined}
                    rel={contact.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                    className={`text-lg font-hero ${contact.color === 'green' ? 'text-green-primary' : 'text-purple-light'} hover:underline block`}
                  >
                    {contact.value}
                  </a>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-16 bg-dark-secondary border border-purple-primary/20 rounded-2xl p-8 text-center">
          <h2 className="text-2xl font-bold font-archive text-white mb-4">
            Horário de Atendimento
          </h2>
          <p className="text-gray-300 font-hero text-lg mb-2">
            Segunda a Sexta: 9h às 18h
          </p>
          <p className="text-gray-300 font-hero text-lg mb-4">
            Sábado: 9h às 14h
          </p>
          <p className="text-gray-400 font-hero text-sm">
            Responderemos sua mensagem em até 72 horas úteis
          </p>
        </div>
      </div>
    </div>
  );
};
